import type {ReactNode} from "react"
import {TextH3} from "@/components/ui/Text"
import css from "./AccountSettingsTitle.module.css"

interface AccountSettingsTitleProps {
    children: ReactNode
}

const AccountSettingsTitle = ({children}: AccountSettingsTitleProps) => {
    return <TextH3 className={css.title}>{children}</TextH3>
}

export default AccountSettingsTitle
